"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImapMicroservicePatterns = void 0;
var ImapMicroservicePatterns;
(function (ImapMicroservicePatterns) {
    ImapMicroservicePatterns["NewMail"] = "IMAP_NEW_MAIL";
    ImapMicroservicePatterns["NewMailAccount"] = "IMAP_NEW_MAIL_ACCOUNT";
    ImapMicroservicePatterns["UpdateMailAccount"] = "IMAP_UPDATE_MAIL_ACCOUNT";
    ImapMicroservicePatterns["ScheduleReconnectMailAccount"] = "SCHEDULE_RECONNECT_SMTP_MAIL_ACCOUNT";
    ImapMicroservicePatterns["ReconnectMailAccount"] = "RECONNECT_IMAP_MAIL_ACCOUNT";
    ImapMicroservicePatterns["DeleteMailAccount"] = "IMAP_DELETE_MAIL_ACCOUNT";
    ImapMicroservicePatterns["GetMailAccountsState"] = "GET_MAIL_ACCOUNTS_STATE";
    ImapMicroservicePatterns["GetMailAccountsWithState"] = "GET_MAIL_ACCOUNTS_WITH_STATE";
})(ImapMicroservicePatterns = exports.ImapMicroservicePatterns || (exports.ImapMicroservicePatterns = {}));
